<template>
    <div class="vlink-strategy-wrap">
        <MaterialTrees type="tip" @getItemDetail="getItemDetail"></MaterialTrees>
        <div class="vlink-strategy-content">
            <GuidesOperate :tagId="currentTagId" :refercence="refercence" @switchClick="switchHandler"></GuidesOperate>
            <div class="vlink-strategy-list">
                <FigureItem
                    v-for="item in strategyData"
                    :key="item.id"
                    :data="item"
                    @checkedClick="itemCheckChange"
                    @editClick="editHandler"
                    @previewClick="previewHandler"
                    @recommendSuccess="recommendSuccess"
                    :iconConfig="iconData"
                    :tagId="currentTagId"
                ></FigureItem>
                <span class="no-data-tip" v-if="strategyData.length == 0">{{ $t("zhiji.common.noData") }}</span>
            </div>
            <div class="page-control">
                <BottomOperateBar
                    :allCheck="allCheckFlag"
                    @allCheckChange="allCheckHandler"
                    @deleteClick="deleteChecked"
                    @transferHandle="transferHandle"
                    v-if="!refercence"
                ></BottomOperateBar>
                <PageControl :total="totalPage" :curPage="curPage" :pageLength="curPageLen" @pageChange="pageChange" />
                <div class="page-length-rank">
                    <span class="total-num">{{ $t("zhiji.materialLibrary.totalOf") + totalPage }}</span>
                    <PageLengthSelect class="length-rank-robot" :pageRank="pageLengthRank" :curLength="curPageLen" @lengthChange="lengthChange" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MaterialTrees from "@/views/zhiji/components/materialLibrary/MaterialTrees";
import FigureItem from "@/views/zhiji/components/materialLibrary/FigureItem";
import BottomOperateBar from "@/views/zhiji/components/materialLibrary/BottomOperateBar";
import PageControl from "@/views/zhiji/bComponents/pageController/PageControl";
import GuidesOperate from "./GuidesOperate";
import TextGuidesEditModel from "./TextGuidesEditModel";
import GuidesViewModal from "@/views/zhiji/components/questionEdit/modals/GuidesViewModal";
import PageLengthSelect from "@/views/zhiji/bComponents/pageController/PageLengthSelect";

import { pageLengthRank } from "@/views/zhiji/components/materialLibrary/materialLibraryConfig.js";
import i18n from "@/i18n";

export default {
    name: "VLinkTextGuides",
    props: ["refercence"],
    components: {
        MaterialTrees,
        GuidesOperate,
        FigureItem,
        PageControl,
        BottomOperateBar,
        PageLengthSelect
    },
    data() {
        return {
            iconData: {
                previewIcon: "-172px -50px",
                previewHoverIcon: "-172px -74px",
                recommendType: "tip"
            },
            curPage: 1,
            curPageLen: 15,
            checkedArr: [],
            pageLengthRank: pageLengthRank,
            currentTagId: "" //当前标签ID
        };
    },
    computed: {
        strategyData() {
            return this.convertListData(this.getStorePorp("classifyData"));
        },
        totalPage() {
            return this.getStorePorp("classifyTotal");
        },
        allCheckFlag() {
            return this.checkedArr.length !== 0 && this.strategyData.length == this.checkedArr.length;
        }
    },
    mounted() {
        this.getVLinkGuidesData();
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.materialLibraryPage[propName];
        },
        recommendSuccess() {
            this.getVLinkGuidesData();
        },
        getVLinkGuidesData() {
            this.$store.dispatch("zhiji/queryGuidesList", {
                page: this.curPage,
                size: this.curPageLen,
                tipName: "",
                source: "",
                sequence: "",
                lang: "",
                tagId: this.currentTagId,
                usageStatus: ''
            });
        },
        getItemDetail(data) {
            this.currentTagId = data.isRoot ? "" : data.tagId;
            this.curPage = 1;
            this.getVLinkGuidesData();
        },
        editHandler(data) {
            !this.refercence &&
                this.zhiji
                    .requestByServiceName("getVlinkGuidesList", {
                        tipId: data.id
                    })
                    .then(data => {
                        this.$store.dispatch("zhiji/showModal", {
                            type: TextGuidesEditModel,
                            data: {
                                type: "edit",
                                strategyData: data.strategyData[0],
                                confirm: () => {
                                    this.$store.dispatch("zhiji/queryGuidesList", {});
                                }
                            }
                        });
                    });
        },
        previewHandler(data) {
            this.zhiji
                .requestByServiceName("getVlinkGuidesList", {
                    tipId: data.id
                })
                .then(data => {
                    this.$store.dispatch("zhiji/showModal", {
                        type: GuidesViewModal,
                        data: {
                            name: data.strategyData[0].title,
                            content: data.strategyData[0].content,
                            updateTime: data.strategyData[0].updateTime
                        }
                    });
                });
        },
        pageChange(data) {
            if (this.curPageLen == data.pageLength && this.curPage == data.curPage) {
                return;
            }
            this.curPageLen = data.pageLength;
            this.curPage = data.curPage;
            this.$store.dispatch("zhiji/queryGuidesList", {
                page: data.curPage,
                size: data.pageLength
            });
            this.checkedArr = [];
            this.removeAllCheck();
            this.$emit("checkClick", {});
        },
        lengthChange(data) {
            if (this.curPageLen == data) {
                return;
            }
            this.curPageLen = data;
            this.$store.dispatch("zhiji/queryGuidesList", {
                page: this.curPage,
                size: this.curPageLen
            });
            this.checkedArr = [];
            this.removeAllCheck();
            this.$emit("checkClick", {});
        },
        itemCheckChange(data) {
            if (data.checked) {
                this.checkedArr.indexOf(data.id) === -1 && this.checkedArr.push(data.id);
            } else {
                let itemcheckedIdx = this.checkedArr.indexOf(data.id);
                itemcheckedIdx !== -1 && this.checkedArr.splice(itemcheckedIdx, 1);
            }

            this.$emit("checkClick", data);
        },
        allCheckHandler(data) {
            data.checked ? this.addAllCheck() : this.removeAllCheck();
        },
        addAllCheck() {
            this.strategyData.forEach(item => {
                this.itemCheckChange({
                    id: item.id,
                    checked: true
                });
            });
        },
        removeAllCheck() {
            this.checkedArr.splice(0);
        },
        deleteChecked() {
            let configText = i18n.t("zhiji.materialLibrary.delGuideConfim");
            const strategyInUseText = i18n.t("zhiji.materialLibrary.prohibitDeleUsingStrate");
            this.checkedArr.length === 0
                ? (configText = i18n.t("zhiji.materialLibrary.optGuideWarn"))
                : this.checkedArr.length > 1
                ? (configText = i18n.t("zhiji.materialLibrary.delGuidesConfim"))
                : "";

            const strategyInUse = this.strategyData.some((strategyDataItem) => {
                return this.checkedArr.some((CheckedItem) => {
                    if (strategyDataItem.id !== CheckedItem) {
                        return false;
                    }
                    return strategyDataItem.relevanceStdQuestionIds && strategyDataItem.relevanceStdQuestionIds.length > 0;
                });
            });
            if (strategyInUse) {
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "error",
                        message: strategyInUseText,
                    },
                });
            } else {
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "tip",
                        message: configText,
                        confirm: () => {
                            if (0 in this.checkedArr) {
                                this.$store.dispatch("zhiji/deleteVLinkGuide", {
                                    tipIds: this.checkedArr.join(",")
                                });
                                this.removeAllCheck();
                            }
                        }
                    }
                });
            }
        },
        transferHandle(datas) {
            if (this.checkedArr.length > 0) {
                this.zhiji
                    .requestByServiceName("transferTip", {
                        ids: this.checkedArr.join(","),
                        tag_new_ids: datas.join(",")
                    })
                    .then(resp => {
                        if (resp == "success") {
                            this.$store.dispatch("zhiji/queryGuidesList", {
                                page: this.curPage,
                                size: this.curPageLen
                            });
                            this.checkedArr.splice(0);
                        }
                    })
            } else {
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "error",
                        message: i18n.t("请至少选择一条攻略")
                    }
                });
            }
        },
        convertListData(data) {
            return data.length > 0
                ? data.map(item => {
                      return {
                          ...item,
                          checked: this.getCheckState(item.id)
                      };
                  })
                : [];
        },
        getCheckState(id) {
            return this.checkedArr.some(itemId => itemId === id);
        },
        switchHandler() {
            this.curPage = 1;
            this.checkedArr = [];
            this.$emit("checkClick", {});
        }
    }
};
</script>

<style scoped lang="less">
.vlink-strategy-wrap {
    height: 100%;
    display: flex;
    .vlink-strategy-content {
        display: flex;
        flex: 1;
        flex-direction: column;
        .vlink-strategy-list {
            display: flex;
            flex: 1;
            justify-content: flex-start;
            align-content: flex-start;
            flex-wrap: wrap;
            background-color: #fff;
            padding: 24px 0 24px 24px;
            box-sizing: border-box;
            overflow-y: auto;
            .no-data-tip {
                flex: 1;
                text-align: center;
                margin-top: -10px;
                color: #9b9ba3;
            }
        }
        .page-control {
            position: relative;
            width: 100%;
            padding: 20px 0;
            text-align: center;
            background: #f2f7fb;
            .page-length-rank {
                margin-right: 20px;
                float: right;
                margin-top: 6px;
                .total-num {
                    font-weight: 700;
                    margin-right: 10px;
                }
                .length-rank-robot {
                    top: -2px;
                }
            }
        }
    }
}
</style>
